import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { endPoint } from "constants/server/api";
import { createFetchLogicPrototype } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
import { http } from "utils/http";
var genReceiptByInvoiceIdSlice = createSlicePrototype({
    name: "genReceiptByInvoiceId"
});
export var genReceiptByInvoiceId = createFetchLogicPrototype({
    actions: genReceiptByInvoiceIdSlice.actions,
    configFn: function(param, param1) {
        var id = param.id, accessToken = param1.accessToken;
        return {
            method: "post",
            url: "".concat(endPoint.NEW_INVOICE, "/").concat(id, "/gen-receipt"),
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            }
        };
    },
    onError: function(error, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        var getStatus = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.status : 500;
        };
        var getMessage = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.data.message : "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง";
        };
        setModalObj === null || setModalObj === void 0 ? void 0 : setModalObj(_object_spread_props(_object_spread({}, modalObj), {
            visible: true,
            subTitle: "รหัส ".concat(getStatus(error)),
            navigateDirection: undefined,
            title: getMessage(error)
        }));
    }
});
export var clearGenReceiptByInvoiceId = function() {
    return function(dispatch) {
        dispatch(genReceiptByInvoiceIdSlice.actions.resetState());
    };
};
var _genReceiptByInvoiceIdSlice_actions = genReceiptByInvoiceIdSlice.actions;
export var fetchData = _genReceiptByInvoiceIdSlice_actions.fetchData, fetchDataSuccess = _genReceiptByInvoiceIdSlice_actions.fetchDataSuccess, fetchDataFailure = _genReceiptByInvoiceIdSlice_actions.fetchDataFailure, resetState = _genReceiptByInvoiceIdSlice_actions.resetState;
export default genReceiptByInvoiceIdSlice.reducer;
